import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../environments/environment';
import { IPromotion } from '../models/promotion.model';

@Injectable({
  providedIn: 'root'
})

export class PromotionApplyService {

  constructor(private http: HttpClient) {}

  loadAllPromotionApplies(page: number, size: number, startDate?: any, endDate?: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));

    // Construire les paramètres de requête
    let params = `?page=${page}&size=${size}`;
    
    // Ajouter les dates si elles existent
    if (startDate) {
        params += `&startDate=${startDate}`;
    }
    if (endDate) {
        params += `&endDate=${endDate}`;
    }

    // Retourner la requête GET avec l'URL complète
    return this.http.get<any>(`${environment.url}/promotionApply/all-promotions${params}`, { headers: headers });
  }

  // api/post-promotion/disable/{id}
  disablePromotionApply(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/promotionApply/disable/` + id, {'headers': headers});
  }

  enablePromotionApply(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/promotionApply/enable/` + id, {'headers': headers});
  }


  // loadAllPromotionApplies(page: number, size: number, startDate?: any, endDate?: any):  Observable<any> {
  //   let headers = new HttpHeaders();
  //   headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  //   return this.http.get<any>(`${environment.url}/promotionApply/all-promotions`+(size ? '?page=' + page + '&size=' + size : ''+`&startDate=${startDate}&endDate=${endDate}`), {'headers': headers});
  // }

  applyPromotionForPostId(postId: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/promotionApply/enable?postId=` + postId, {'headers': headers});
  }

  savePromotionApply(promotion: IPromotion, postId: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/promotionApply?postId=${postId}`, promotion, {'headers': headers});
  }

  getListPostIdPromotionAppy():  Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/promotionApply/list-postId`, {'headers': headers});
  }
  
  deletePrmotionApplyByPostid(postId: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/promotionApply/` + postId, {'headers': headers});
  }

}